import React from "react"
import { Grid, TextField, Typography, Select, MenuItem } from "@material-ui/core"
import { DeleteOutlined as DeleteIcon, PlaylistAdd as FieldIcon } from "@material-ui/icons"

import useStyles from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/resources/Blocks/CustomFieldFillBlock/CustomFieldCard/styles"

type CustomFieldCardProps = {
	fieldName: string
	instruction: string
	conflictRule: "overwrite" | "keep"
	onInstructionChange: (instruction: string) => void
	onConflictRuleChange: (conflictRule: "overwrite" | "keep") => void
	onRemove: () => void
}

const INSTRUCTION_LABEL = "Quando a IA deve preencher este campo"
const INSTRUCTION_PLACEHOLDER = "Descreva quando a IA deve preencher este campo"
const CONFLICT_LABEL = "Se o campo já tiver valor"
const CONFLICT_OVERWRITE_LABEL = "Sobrescrever o valor"
const CONFLICT_KEEP_LABEL = "Manter o valor atual"

const CustomFieldCard: React.FC<CustomFieldCardProps> = (props) => {
	const {
		fieldName,
		instruction,
		conflictRule,
		onInstructionChange,
		onConflictRuleChange,
		onRemove
	} = props

	const classes = useStyles()

	const handleInstructionChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		onInstructionChange(event.target.value)
	}

	const handleConflictRuleChange = (event: React.ChangeEvent<unknown>) => {
		onConflictRuleChange((event.target as HTMLInputElement).value as "overwrite" | "keep")
	}

	return (
		<Grid className={classes.card}>
			<Grid
				container
				alignItems="center"
				className={classes.cardHeader}
			>
				<Grid
					item
					className={classes.fieldIconWrapper}
				>
					<FieldIcon className={classes.fieldIcon} />
				</Grid>

				<Grid
					item
					xs
				>
					<Typography className={classes.fieldName}>
						{fieldName}
					</Typography>
				</Grid>

				<Grid
					item
					className={classes.removeButton}
					onClick={onRemove}
				>
					<DeleteIcon className={classes.removeIcon} />
				</Grid>
			</Grid>

			<Grid className={classes.instructionBlock}>
				<Typography className={classes.instructionLabel}>
					{INSTRUCTION_LABEL}
				</Typography>

				<TextField
					multiline
					rows={2}
					fullWidth
					placeholder={INSTRUCTION_PLACEHOLDER}
					value={instruction}
					onChange={handleInstructionChange}
					variant="outlined"
					className={classes.instructionField}
				/>
			</Grid>

			<Grid className={classes.conflictRow}>
				<Typography className={classes.conflictLabel}>
					{CONFLICT_LABEL}
				</Typography>

				<Select
					value={conflictRule}
					onChange={handleConflictRuleChange}
					variant="outlined"
					className={classes.conflictSelect}
				>
					<MenuItem value="overwrite">
						{CONFLICT_OVERWRITE_LABEL}
					</MenuItem>
					<MenuItem value="keep">
						{CONFLICT_KEEP_LABEL}
					</MenuItem>
				</Select>
			</Grid>
		</Grid>
	)
}

export default CustomFieldCard
